module.exports = __webpack_public_path__ + "img/yp.d2c263ed.png";